module.exports = __webpack_public_path__ + "media/components/weather-icon/static/daysnowshowers@3-9f68b8b0bf8aa329574a764db1dfc78d.png";